import React from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import { FiTarget, FiDollarSign, FiMessageSquare, FiArrowRight } from 'react-icons/fi';

const WebinarContent = ({ onOpenModal }) => {
  const content = [
    {
      title: "Cosa vendere per arrivare a 6K",
      desc: "Come scegliere l’offerta giusta (servizi, pacchetti o prodotti) in base alle tue competenze e a ciò che il mercato compra davvero.",
      icon: FiTarget
    },
    {
      title: "High ticket offer",
      desc: "Strategie pratiche per definire prezzi sostenibili e profittevoli, senza svenderti né spaventare i clienti.",
      icon: FiDollarSign
    },
    {
      title: "Come chiudere dai social",
      desc: "Il processo passo-passo per trasformare contenuti e conversazioni in DM in clienti paganti.",
      icon: FiMessageSquare
    }
  ];

  return (
    <section className="py-24 bg-black-pure relative">
      <div className="container mx-auto px-6">
        <div className="text-center mb-16">
          <motion.h2 
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            className="text-3xl md:text-5xl font-black text-white uppercase tracking-tighter"
          >
            COSA TROVERAI NEL <span className="text-orange-500 italic">WEBINAR?</span>
          </motion.h2>
          <div className="w-24 h-1 bg-orange-600 mx-auto mt-6 rounded-full"></div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-16">
          {content.map((item, i) => (
            <motion.div 
              key={i}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: i * 0.1 }}
              className="glass-card-dark p-8 rounded-[2.5rem] flex flex-col items-center text-center group"
            >
              <div className="w-16 h-16 bg-orange-600/10 rounded-2xl flex items-center justify-center text-orange-500 mb-8 group-hover:bg-orange-600 group-hover:text-white transition-all duration-500">
                <SafeIcon icon={item.icon} className="text-3xl" />
              </div>
              <h3 className="text-xl font-black text-white mb-4 uppercase tracking-tight">
                {item.title}
              </h3>
              <p className="text-slate-400 font-medium leading-relaxed">
                {item.desc}
              </p>
            </motion.div>
          ))}
        </div>

        <motion.div 
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="flex justify-center"
        >
          <button 
            onClick={onOpenModal}
            className="btn-premium text-white px-12 py-5 rounded-2xl font-black text-xl flex items-center space-x-3 shadow-[0_0_50px_rgba(249,115,22,0.3)] hover:shadow-[0_0_70px_rgba(249,115,22,0.5)] transition-all duration-300"
          >
            <span>Iscriviti</span>
            <SafeIcon icon={FiArrowRight} />
          </button>
        </motion.div>
      </div>
    </section>
  );
};

export default WebinarContent;